module.exports = __webpack_public_path__ + "static/media/resume-background-large.897cb774.jpg";